import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Header extends Component {

  render() {
    return (
      <nav className="bg-background border-b border-outline-variant z-50 sticky top-0">
        <div className="flex justify-between items-center gap-4 md:gap-8 w-full px-margin-mobile md:px-margin-desktop py-4 max-w-container-max mx-auto">
          <NavLink to="/" className="font-headline-xl text-headline-xl font-bold tracking-tighter text-on-background flex items-center gap-2 shrink-0">
            <span className="material-symbols-outlined text-primary-container text-4xl">mic</span>
            <span className="hidden sm:inline">FROM ZERO TO N</span>
          </NavLink>

          {/* Search */}
          <div className="flex-1 max-w-xl relative">
            <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-on-surface-variant">search</span>
            <input
              className="w-full bg-surface-container border border-outline-variant rounded py-2.5 pl-12 pr-4 text-on-surface font-body-md focus:border-primary-container focus:ring-1 focus:ring-primary-container transition-all outline-none"
              placeholder="Search episodes..."
              type="text"
              value={this.props.query || ''}
              onChange={this.props.onSearch}
            />
          </div>

          <a className="text-primary hover:text-secondary transition-colors duration-200 shrink-0"
             href="https://open.spotify.com/show/1BeAW7hI9MSdloLx7mnQUQ?si=9d426df2fada42fb" target="_blank" rel="noopener noreferrer">
            <span className="material-symbols-outlined">rss_feed</span>
          </a>
        </div>
      </nav>
    );
  }

}
export default Header;
